import { ItemGroup } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { mq, padding } from '@sleepstation/style-api-helpers'
import { outset } from '@sleepstation/style-mixins'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import MailingListSignupAction from './MailingListSignupAction'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const TITLE = `Join our community`
const BODY = `Our team reviews scientific literature and curates relevant information about sleep and insomnia for our readers. Receive useful information from leading sleep experts and actionable sleep tips straight to your inbox, completely free of charge.`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(ItemGroup)``

const Wrapper = styled.div`
  ${mq(`smallUp`)} {
    ${padding(2)}
    ${outset()}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalMailingListSignup = ({ dataCy }) => (
  <Wrapper data-cy={dataCy}>
    <Layout title={TITLE} bodySpacing={1}>
      <CopyParagraph>{BODY}</CopyParagraph>
      <ThemeProvider theme={defaultAltTheme}>
        <MailingListSignupAction />
      </ThemeProvider>
    </Layout>
  </Wrapper>
)

PortalMailingListSignup.propTypes = { dataCy: PropTypes.string }

PortalMailingListSignup.defaultProps = { dataCy: null }

export default PortalMailingListSignup
